import type { SaveGame } from '../types';

export const createNewSave = (name: string): SaveGame => ({
  id: -1, // Temporary ID, will be replaced by server
  name,
  createdAt: new Date().toISOString(),
  walnuts: {},
});


